<template>
  <div>
    <div class="banner">
      <!-- <img :src="$store.state.islogin ? logBanner : banner" v-if="clientWidth > 768" alt="" /> -->
      <img :src="banner" v-if="clientWidth > 768" alt="" />
      <img :src="banner_m" v-if="clientWidth <= 768" alt="" />
      <!-- <div class="banner-button btns" @click="handleLive" v-ga="{ event: 'trk', ec: 'banner', ea: 'signup', el: 'onlinetour' }" >
        <span style="font-weight: bold">观看回放</span>
        <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_next1.png" alt="" />
      </div> -->
    </div>
    <!-- 大会介绍及亮点 -->
    <div class="module module1">
      <div class="wrap">
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title1 }}</span>
          <img :src="rightimg" alt="" />
        </div>
        <div class="introduce">
          以<span style="color:#3dcd58">“智 · 在其间”</span>为主题，施耐德电气在 2026 工博会全面展示软件定义的自动化、工业 AI
          与数字化创新技术的融合实践，通过贯穿接入适配、运营控制、管理优化的全域智能能力，助力千行百业应对挑战、驾驭变化、创造价值。
        </div>

        <Introswiper :introllist="introllist" style="display: none;"></Introswiper>

        <div style="margin-top: 20px;" class="btns intro_btn" @click="handleApply"
          v-ga="{ event: 'trk', ec: 'highlight', ea: 'signup', el: 'onlinetour', }" v-if="!$store.state.islogin">
          <span>立即报名云游工博会</span>
          <img :src="Res_Url + '/index/icon_next1.png'" alt="" />
        </div>
      </div>
    </div>

    <!-- 大会日程 -->
    <div class="module module2" id="id1">
      <div class="wrap">
        <div class="new-iconblock">
          <img :src="Res_Url + '/index/icon-newblock.png'" class="img_auto" alt="" />
        </div>
        <div class="title_box title_box2 fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title2 }}</span>
          <img :src="rightimg" alt="" />
        </div>

        <!-- 视频 -->
        <div class="video_box">
          <div class="video_left" v-if="!kolTrue && getCurrentVideoData()">
            <div>
              <img :src="Res_Url2026 + '/index/module2_cover1.png'" alt="" />
              <img class="acenter" @click="toLive(getCurrentVideoData())" :src="Res_Url2026 + '/index/icon_play.png'"
                alt="" />
            </div>
            <span>{{ getCurrentVideoData().liveInfo.name }}</span>
          </div>
          <div class="video_left" v-else>
            <div>
              <img :src="Res_Url2026 + '/index/module2_cover1.png'" alt="" />
              <img class="acenter" @click="toLive({ date: 'kol', })" :src="Res_Url2026 + '/index/icon_play.png'"
                alt="" />
            </div>
            <span>云探工博会</span>
          </div>
          <div class="video_right">
            <div class="video_right_title">
              <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_1.png" alt="" />
              <span>视频列表</span>
            </div>
            <div class="video_right_box" v-if="clientWidth > 768">
              <div class="video_right_content" v-for="(item, index) in agendaReverse" :key="index">
                <div>
                  <img :src="Res_Url2026 + '/index/module2_cover1.png'" alt="" />
                  <img class="acenter" @click="toLive(item)" :src="Res_Url2026 + '/index/icon_play.png'" alt="" />
                </div>
                <span>{{ item.liveInfo.name }}</span>
              </div>
            </div>
            <swiper :options="swiperOption_ms" ref="mySwiper" :auto-play="true" v-else class="video_right_box">
              <div v-if="clientWidth < 768" class="swiper-button-prev" slot="button-prev"></div>
              <div v-if="clientWidth < 768" class="swiper-button-next" slot="button-next"></div>
              <swiper-slide v-for="(item, index) in agendaReverse" :key="index" class="video_right_content">
                <div>
                  <img :src="Res_Url2026 + '/index/module2_cover1.png'" alt="" />
                  <img class="acenter" @click="toLive(item)" :src="Res_Url2026 + '/index/icon_play.png'" alt="" />
                </div>
                <span>{{ item.liveInfo.name }}</span>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <!-- tab -->
        <div class="agenda_box">
          <ul class="info_tabs">
            <li :class="currentIndex == index ? 'tab_active' : ''" v-for="(item, index) in timeList" :key="item"
              @click="handleTab(index)" v-ga="{ event: 'trk', ec: 'agenda', ea: 'tab', el: 'fold' }">
              <span>{{ item }}</span>
            </li>
          </ul>
          <div class="agenda_remark">*具体直播安排以现场为准</div>
          <div class="agenda_scroll">
            <div class="agenda_boxs">
              <div class="agenda_am">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_3.png" alt="" />
              </div>
              <!-- v-for="(item, index) in agendaData[currentIndex].timeList.AM.filter((item) => item.content !== '')" -->
              <div class="agenda_item" v-for="(item, index) in agendaData[currentIndex].timeList.AM" :key="index">
                <div class="agenda_time" v-if="clientWidth > 768"> {{ item.time }} </div>

                <div class="agenda_content">
                  <img class="icon_circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png"
                    alt="" />
                  <div class="agenda_top">
                    <span class="agenda_time_m" v-if="clientWidth <= 768">{{ item.time }}</span>
                    <p v-html="item.title.split('\n').join('<br>')"></p>
                    <div v-if="item.content || item.name" @click="handleIsshow1(index)"
                      v-ga="{ event: 'trk', ec: 'agenda', ea: 'showmore', el: 'fold', }">
                      <span>{{ item.isshow ? "收起" : "展开" }}</span>
                      <img v-if="item.isshow" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_up.png" alt="" />
                      <img v-if="!item.isshow" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_down.png" alt="" />
                    </div>
                  </div>
                  <div class="agenda_h" v-if="clientWidth > 768"></div>
                  <el-collapse-transition>
                    <div class="agenda_down" v-show="item.isshow">
                      <span v-if="item.content" class="agenda_title">演讲介绍</span>
                      <p v-if="item.content" v-html="item.content.split('\n').join('<br>')"></p>
                      <div class="agenda_people">
                        <div>
                          <span v-if="item.name">演讲人：{{ item.name }}</span>
                          <span v-html="item.position"></span>
                        </div>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
            <div class="agenda_boxs">
              <div class="agenda_pm">
                <img src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_4.png" alt="" />
              </div>
              <!-- v-for="(item, index) in agendaData[currentIndex].timeList.PM.filter((item) => item.content !== '')" -->
              <div class="agenda_item" v-for="(item, index) in agendaData[currentIndex].timeList.PM" :key="item.title">
                <div class="agenda_time" v-if="clientWidth > 768"> {{ item.time }} </div>

                <div class="agenda_content">
                  <img class="icon_circle" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_module2_2.png"
                    alt="" />
                  <div class="agenda_top">
                    <span class="agenda_time_m" v-if="clientWidth <= 768">{{ item.time }}</span>
                    <p v-html="item.title.split('\n').join('<br>')"></p>
                    <div v-if="item.content || item.name" @click="handleIsshow2(index)">
                      <span>{{ item.isshow ? "收起" : "展开" }}</span>
                      <img v-if="item.isshow" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_up.png" alt="" />
                      <img v-if="!item.isshow" src="https://staticdn.ht-s.cn/se/ciif/2024/index/icon_down.png" alt="" />
                    </div>
                  </div>
                  <div class="agenda_h" v-if="clientWidth > 768"></div>
                  <el-collapse-transition>
                    <div class="agenda_down" v-show="item.isshow">
                      <span v-if="item.content" class="agenda_title">演讲介绍</span>
                      <p v-if="item.content" v-html="item.content.split('\n').join('<br>')"></p>
                      <div class="agenda_people">
                        <div>
                          <span v-if="item.name">演讲人：{{ item.name }}</span>
                          <span v-html="item.position"></span>
                        </div>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 云导览 -->
    <div class="module module3" id="id2">
      <div class="wrap">
        <div class="new-iconblock-left">
          <img :src="Res_Url + '/index/icon-newblock.png'" class="img_auto" alt="" />
        </div>
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title3 }}</span>
          <img :src="rightimg" alt="" />
        </div>
        <div class="title_box1 fx2">
          <img :src="leftimg2" alt="" />
          <span>{{ text3 }}</span>
          <img :src="rightimg2" alt="" />
        </div>
        <div class="AR_box">

          <img :src="module3_img" v-if="clientWidth > 768" alt="" @click="handleYDL(0)"
            v-ga="{ event: 'trk', ec: 'guide', ea: 'guideall' }" />
          <!-- @click="handleYDL(0)" -->
          <img :src="module3_img_m" v-if="clientWidth <= 768" @click="handleYDL(0)" alt=""
            v-ga="{ event: 'trk', ec: 'guide', ea: 'guideall' }" />
          <!-- @click="handleYDL(0)"  -->
          <div class="point_box point1" v-ga="{ event: 'trk', ec: 'guide', ea: 'ProcessMixed' }" @click="handleYDL(0)">
            <div class="point_box_dian"></div><span>流程/混合行业</span>
          </div>
          <div class="point_box point2" v-ga="{ event: 'trk', ec: 'guide', ea: 'DiscreteIndustry' }"
            @click="handleYDL(1)">
            <span>离散行业</span>
            <div class="point_box_dian"></div>
          </div>
          <div class="point_box point3" v-ga="{ event: 'trk', ec: 'guide', ea: 'dataCentre' }" @click="handleYDL(2)">
            <span>数据中心行业</span>
            <div class="point_box_dian"></div>
          </div>
          <div class="point_box point4" v-ga="{ event: 'trk', ec: 'guide', ea: 'waterReg' }" @click="handleYDL(3)">
            <div class="point_box_dian"></div><span>市政行业</span>

          </div>
          <div class="point_box point5" v-ga="{ event: 'trk', ec: 'guide', ea: 'consult' }" @click="handleYDL(4)">
            <div class="point_box_dian"></div><span></span>
          </div>
          <div class="point_box point6" v-ga="{ event: 'trk', ec: 'guide', ea: 'control' }" @click="handleYDL(5)">
            <div class="point_box_dian"></div><span></span>
          </div>

        </div>
        <!-- 移动端需要 -->
        <div class="point_box_list">
          <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'ProcessMixed' }" @click="handleYDL(0)">
            流程/混合行业
          </div>
          <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'DiscreteIndustry' }"
            @click="handleYDL(1)">
            离散行业
          </div>
          <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'dataCentre' }" @click="handleYDL(2)">
            数据中心行业
          </div>
          <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'waterReg' }" @click="handleYDL(3)">
            市政行业
          </div>
          <!-- <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'consult' }" @click="handleYDL(4)">
            咨询
          </div>
          <div class="point_box-item" v-ga="{ event: 'trk', ec: 'guide', ea: 'control' }" @click="handleYDL(5)">
            工控邦
          </div> -->

        </div>
      </div>
    </div>

    <!-- 新品展示 -->
    <div class="module module4" id="id3">
      <div class="wrap">
        <div class="new-iconblock">
          <img :src="Res_Url + '/index/icon-newblock.png'" class="img_auto" alt="" />
        </div>
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title4 }}</span>
          <img :src="rightimg" alt="" />
        </div>

        <div class="fx2">
          <div class="select_box">
            <div class="tab1 fx2" :class="!select_tab4 ? 'select_a' : ''" @click="handleSelectTab4(false)"
              v-ga="{ event: 'trk', ec: 'news', ea: 'iac', el: 'iac' }">
              工业自动化
            </div>
            <!-- <div class="tab2" :class="select_tab4 ? 'select_active' : ''"></div> -->
            <div class="tab3 fx2" :class="select_tab4 ? 'select_a' : ''" @click="handleSelectTab4(true)"
              v-ga="{ event: 'trk', ec: 'news', ea: 'em', el: 'em' }">
              能源管理
            </div>
          </div>
        </div>

        <Exhibswiper :tab="select_tab4" :data="exhibitionData"></Exhibswiper>
      </div>
    </div>

    <!-- 下载中心 -->
    <div class="module module5" id="id4">
      <div class="wrap">
        <div class="new-iconblock-left">
          <img :src="Res_Url + '/index/icon-newblock.png'" class="img_auto" alt="" />
        </div>
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title5 }}</span>
          <img :src="rightimg" alt="" />
        </div>

        <div class="fx2">
          <div class="select_box">
            <div class="tab1 fx2" :class="!select_tab5 ? 'select_a' : ''" @click="handleSelectTab5(false)"
              v-ga="{ event: 'trk', ec: 'download', ea: 'insights', el: 'insights', }">
              行业洞察
            </div>
            <!-- <div class="tab2" :class="select_tab5 ? 'select_active' : ''"></div> -->
            <div class="tab3 fx2" :class="select_tab5 ? 'select_a' : ''" @click="handleSelectTab5(true)"
              v-ga="{ event: 'trk', ec: 'download', ea: 'stories', el: 'lio' }">
              客户案例
            </div>
          </div>
        </div>
        <Downswiper id="abc" :tab="select_tab5" :data="downloadCenterData"></Downswiper>
      </div>
    </div>

    <!-- 行业云展厅 -->
    <!-- <div class="module module6" id="id5">
      <div class="wrap">
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title6 }}</span>
          <img :src="rightimg" alt="" />
        </div>
        <Positiswiper :list="modulelist6" @Visitlink="handleVisit"></Positiswiper>
      </div>
    </div> -->

    <!-- 大会指南 -->
    <div class="module module7" id="id7">
      <div class="wrap">
        <div class="new-iconblock">
          <img :src="Res_Url + '/index/icon-newblock.png'" class="img_auto" alt="" />
        </div>
        <div class="title_box fx2">
          <img :src="leftimg" alt="" />
          <span>{{ title7 }}</span>
          <img :src="rightimg" alt="" />
        </div>
        <div class="module7_box">
          <div class="module7_left">
            <Map></Map>
          </div>
          <div class="module7_right">
            <div class="module7_title">参会信息</div>
            <div class="module7_content">
              <div class="modult_time">
                <img :src="Res_Url + '/index/icon_address.png'" class="img_auto" alt="" />
                <div>
                  <p>会议地点：</p>
                  <span>上海国家会展中心6.1号馆 C127 号展位</span>
                  <span>上海市青浦区崧泽大道333号</span>
                </div>
              </div>
              <div class="modult_time">
                <img :src="Res_Url + '/index/icon_time.png'" class="img_auto" alt="" />
                <div>
                  <p>会议时间：</p>
                  <span>2026年10月12日-10月16日</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Rdialog :isRegister="isRegister" :isEmail="isEmail" :isLive="isLive" :liveText="liveText" :isIntegral="isIntegral"
      :integralText="integralText" @handleClose="handleClose"></Rdialog>
  </div>
</template>
<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

import Introswiper from "@/components/introswiper/index.vue";
import Exhibswiper from "@/components/exhibswiper/index.vue";
import Downswiper from "@/components/downswiper/index.vue";
// import Positiswiper from "@/components/positiswiper/index.vue";
import Rdialog from "@/components/rdialog/index.vue";
import Map from "@/components/map/index.vue";
import downloadCenterData from "@/assets/json/downloadCenter.json";
import exhibitionData from "@/assets/json/exhibition.json";
import agendaData from "@/assets/json/agenda.json?v=20240925";
import { GetUserLogs } from "@/api/index.js";
import { ApiToken, Res_Url, Res_Url2026 } from '@/utils/ApiToken'
import { Alert } from "element-ui";
export default {
  data() {
    return {
      Res_Url: Res_Url,
      Res_Url2026: Res_Url2026,
      downloadCenterData,
      exhibitionData,
      agendaData,
      isRegister: false,
      isEmail: false,
      isLive: false,
      swiperOption_ms: {
        direction: "horizontal",
        // autoplay: {
        //   delay: 5000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        slidesPerView: "auto",
        centeredSlides: true,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionStart: (swiper) => {
            if (swiper.realIndex === 0) {
              document.querySelector(".video_right_box .swiper-wrapper").style.left = (-10 / 75) * 100 + "vw";
            } else if (swiper.realIndex === 4) {
              document.querySelector(".video_right_box .swiper-wrapper").style.left = (10 / 75) * 100 + "vw";
            } else {
              document.querySelector(".video_right_box .swiper-wrapper").style.left = 0;
            }
          },
        },
      },
      banner: Res_Url2026 + "/index/banner.png",
      logBanner: Res_Url + "/personal/banner.png",
      banner_m: Res_Url2026 + "/index/banner_m.png",
      notice: "为了庆祝成立一周年，将开启限时抢购活动，快来参与吧!",
      leftimg: Res_Url + "/index/icon_left1.png",
      rightimg: Res_Url + "/index/icon_right1.png",
      title1: "亮点抢先看",
      introllist: [
        {
          img: Res_Url + "/index/1_card3.png",
          title: "数字化加速",
          children: [
            "基于开放自动化平台的产线级演示",
            "探秘端到端“灯塔工厂”",
            "AVEVA 沉浸式仿真培训系统",
            "预测性维护",
            "一体化运营中心",
            "PI System 工业大数据管理平台",
          ],
        },
        {
          img: Res_Url + "/index/1_card2.png",
          title: "可持续发展",
          children: [
            "工业碳中和咨询解决方案",
            "绿色智能制造咨询解决方案",
            "绿色能源管理整体解决方案",
          ],
        },
        {
          img: Res_Url + "/index/1_card1.png",
          title: "未来工业",
          children: [
            "全生命周期数字孪生解决方案",
            "面向工业市场的 EcoStruxure™ 架构",
            "轻量级 MES 实践案例",
            "工厂顾问数字化解决方案",
            "一站式服务解决方案",
          ],
        },
      ],

      title2: "大会日程",
      videolist: [
        {
          title: "数字驱动 尽享其用  施耐德电气变频顾问介绍",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "生产智能化 - 先进控制与在线实时优化",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "如何重塑未来工业？—— 施耐德电气 EcoStruxure™ 开放自动化平台",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "一体化原油计划调度 —— 价值链优化 Spiral",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "身临其境的工业操作培训体验  AVEVA XR for Training",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title:
            "想要生产更灵活？高手看过来 —— 施耐德电气发布全新 Lexium MC12 柔性输送系统",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "实现数字孪生的第一步 三维设计软件 AVEVA E3D Design",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title:
            "哇哦，这个产品怎么这么开放透明灵活？—— 施耐德电气大型 PLC 硬核升级",
          img: Res_Url + "/index/module2_cover1.png",
        },
        {
          title: "灯塔工厂咨询服务",
          img: Res_Url + "/index/module2_cover1.png",
        },
      ],
      currentIndex: 0,
      timeList: ["10月12日", "10月13日", "10月14日"],
      title3: "云导览",
      leftimg2: Res_Url + "/index/icon_left2.png",
      rightimg2: Res_Url + "/index/icon_right2.png",
      text3: "点击下方区域热点，即可查看详情",
      module3_img: Res_Url2026 + "/index/module3.png",
      module3_img_m: Res_Url2026 + "/index/module3.png",
      title4: "新品展示",
      select_tab4: false,
      modulelist4: [],
      modulelist4_m: [],

      title5: "下载中心",
      select_tab5: false,
      title6: "行业云展厅",
      modulelist6: [
        {
          title: "施耐德电气化工油气行业云展厅",
          img: Res_Url + "/index/module6_1.png",
          text: "数字先行，保障化工油气行业安全<span style='color: rgb(61,205,88)'>可靠</span>发展",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=China_All_CN_202206_Virtual-Innovation-Hub&utm_source=SESocialETC&utm_medium=social#/%E5%8C%96%E5%B7%A5%E6%B2%B9%E6%B0%94/%E7%8E%B0%E5%9C%BA%E8%AE%BE%E5%A4%87",
        },
        {
          title: "施耐德电气食品&饮料行业云展厅",
          img: Res_Url + "/index/module6_2.png",
          text: "以<span style='color: rgb(61,205,88)'>创新</span>技术，提升食品饮料行业智能化水平",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=China_All_CN_202206_Virtual-Innovation-Hub&utm_source=SESocialETC&utm_medium=social#/%E9%A3%9F%E5%93%81%E9%A5%AE%E6%96%99/%E7%81%8C%E5%8C%85%E8%A3%85%E5%8C%BA",
        },
        {
          title: "施耐德电气水泥行业云展厅",
          img: Res_Url + "/index/module6_3.png",
          text: "高效运营，提升水泥行业<span style='color: rgb(61,205,88)'>能效</span>水平",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=China_All_CN_202206_Virtual-Innovation-Hub&utm_source=SESocialETC&utm_medium=social#/%E6%B0%B4%E6%B3%A5/%E6%B0%B4%E6%B3%A5%E5%8E%82%E4%B8%AD%E5%A4%AE%E6%8E%A7%E5%88%B6%E5%AE%A4",
        },
        {
          title: "施耐德电气物流行业云展厅",
          img: Res_Url + "/index/module6_4.png",
          text: "智慧高效，提升物流行业运营<span style='color: rgb(61,205,88)'>效率</span>",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=China_All_CN_202206_Virtual-Innovation-Hub&utm_source=SESocialETC&utm_medium=social#/%E7%89%A9%E6%B5%81/%E8%BE%93%E9%80%81",
        }, {
          title: "施耐德电气电网行业云展厅",
          img: require('@/assets/index/module6_5.png'),
          text: "绿色智能，助力新型电力系统下的电网<span style='color: rgb(61,205,88)'>高质量发展</span>",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=CN_202206_ALL-VIRTUAL-INNOVATION-HUB&utm_source=SESocialETC&utm_medium=social#/%E7%94%B5%E7%BD%91/%E6%96%B0%E8%83%BD%E6%BA%90",
        }, {
          title: "施耐德电气水务及环保公用事业行业云展厅",
          img: require('@/assets/index/module6_6.png'),
          text: "物联赋能，迈向绿色<span style='color: rgb(61,205,88)'>智慧</span>水务",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=CN_202206_ALL-VIRTUAL-INNOVATION-HUB&utm_source=SESocialETC&utm_medium=social#/%E6%B0%B4%E5%8A%A1/%E7%94%9F%E4%BA%A7%E8%BF%87%E7%A8%8B",
        }, {
          title: "施耐德电气新能源行业云展厅",
          img: require('@/assets/index/module6_7.png'),
          text: "新能致远，<span style='color: rgb(61,205,88)'>施在必行</span>",
          link: "https://events.schneider-electric.cn/segment_virtual_hub/?utm_campaign=CN_202206_ALL-VIRTUAL-INNOVATION-HUB&utm_source=SESocialETC&utm_medium=social#/%E6%96%B0%E8%83%BD%E6%BA%90/%E9%99%86%E4%B8%8A%E9%A3%8E%E5%8A%9B%E5%8F%91%E7%94%B5",
        }, {
          title: "施耐德电气数字能效体验馆",
          img: require('@/assets/index/module6_8.png'),
          text: "深度互动，解锁全场景<span style='color: rgb(61,205,88)'>数字能效软件体验</span>",
          link: "https://wechat.schneider-electric.cn/dec/",
        }
      ],

      title7: "参会指南",
      module7_img: Res_Url + "/index/module7.png",
      module7_img_m: Res_Url + "/index/module7_m.png",
      liveText: "",
      scroll: "",
      kolTrue: false,
      isIntegral: false,
      integralText: "",
      objs: {},
      currentVideoIndex: 0 // 跟踪当前显示的视频索引
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Introswiper,
    Exhibswiper,
    Downswiper,
    // Positiswiper,
    Rdialog,
    Map,
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-首页",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058,
    });
    this.getToday();
    window.addEventListener("scroll", this.handleScroll);
    setTimeout(() => {
      if (this.clientWidth > 768) {
        this.agendaData.map((item) => {
          if (item.timeList.AM[0].content || item.timeList.AM[0].name) {
            item.timeList.AM[0].isshow = true;
          }
        });
      }
      if (this.mode) {
        const element = document.querySelector("#" + this.mode);
        if (element) {
          let top = element.offsetTop;
          document.body.scrollTop = document.documentElement.scrollTop = top - 50;
        }
      }
    }, 100);
  },
  methods: {
    handleLive() {
      if (this.$store.state.islogin) {
        let params = this.$route.query;
        this.$router.push({
          path: '/Home/Index',
          query: {
            track: params.track ? params.track : "",
            utm_source: params.utm_source ? params.utm_source : "",
            utm_medium: params.utm_medium ? params.utm_medium : "",
            utm_campaign: params.utm_campaign ? params.utm_campaign : "",
            utm_content: params.utm_content ? params.utm_content : "",
            se_sr: params.se_sr ? params.se_sr : "",
            se_md: params.se_md ? params.se_md : "",
            se_ct: params.se_ct ? params.se_ct : "",
            mode: "id1",
          },
        });
        this.$store.commit("activeIndex", 1);
      } else {
        let params = this.$route.query;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        let querys;
        querys = {
          backlink: encodeURIComponent(window.location.href),
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        };
        this.$router.push({
          name: "Register",
          query: querys,
        });
      }
    },
    getToday() {
      let date = new Date;
      const today = date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');

      const index = this.agendaData.findIndex(item => item.date.split(' ')[0] === today);

      this.currentIndex = index === -1 ? 0 : index;

      // 初始化时设置当前视频索引
      if (this.agendaData[this.currentIndex] &&
        this.agendaData[this.currentIndex].liveInfo &&
        this.agendaData[this.currentIndex].liveInfo.name &&
        this.agendaData[this.currentIndex].liveInfo.name !== "false" &&
        this.agendaData[this.currentIndex].liveInfo.name.trim() !== '') {
        this.currentVideoIndex = this.currentIndex;
      } else {
        // 如果当前索引没有有效视频，找到第一个有效的
        const validIndex = this.getValidVideoIndex(this.currentIndex);
        this.currentVideoIndex = validIndex !== -1 ? validIndex : 0;
      }
      // 展示逛展直播代提供时间
      if (Date.now() >= new Date("2026-10-12 10:30:00".replace(/-/g, "/")).getTime() && Date.now() <= new Date("2026-10-12 11:30:00".replace(/-/g, "/")).getTime()) {
        this.kolTrue = true;
      }

      if (Date.now() >= new Date("2026-10-15 09:00:00".replace(/-/g, "/")).getTime()) {
        this.currentIndex = 0
        this.currentVideoIndex = 0
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },
    handleApply() {
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let querys;
      querys = {
        backlink: encodeURIComponent(window.location.href),
        track: params.track ? params.track : "",
        utm_source: params.utm_source ? params.utm_source : "",
        utm_medium: params.utm_medium ? params.utm_medium : "",
        utm_campaign: params.utm_campaign ? params.utm_campaign : "",
        utm_content: params.utm_content ? params.utm_content : "",
        se_sr: params.se_sr ? params.se_sr : "",
        se_md: params.se_md ? params.se_md : "",
        se_ct: params.se_ct ? params.se_ct : "",
      };
      this.$router.push({
        name: "Register",
        query: querys,
      });
    },
    handleTab(index) {
      document.querySelector(".agenda_scroll").scrollTop = 0;
      this.currentIndex = index;

      // 如果切换到的标签有有效视频内容，更新当前视频索引
      if (this.agendaData[index] &&
        this.agendaData[index].liveInfo &&
        this.agendaData[index].liveInfo.name &&
        this.agendaData[index].liveInfo.name !== "false" &&
        this.agendaData[index].liveInfo.name.trim() !== '') {
        this.currentVideoIndex = index;
      } else {
        // 如果切换到的标签没有有效视频内容（如9月26日），显示第一天的内容
        this.currentVideoIndex = 0;
      }
    },
    handleIsshow1(aindex) {
      // this.agendaData[this.currentIndex].timeList.AM.filter((item) => item.content !== "")
      this.agendaData[this.currentIndex].timeList.AM.map((item, index) => {
        if (index == aindex) {
          item.isshow = !item.isshow;
        }
      });
    },
    handleIsshow2(aindex) {
      // this.agendaData[this.currentIndex].timeList.PM.filter((item) => item.content !== "")
      this.agendaData[this.currentIndex].timeList.PM.map((item, index) => {
        if (index == aindex) {
          item.isshow = !item.isshow;
        }
      });
    },
    handleSelectTab4(flag) {
      this.select_tab4 = flag;
    },
    handleSelectTab5(flag) {
      this.select_tab5 = flag;
    },
    handleVisit(link) {
      window.open(link);
    },
    handleClose() {
      this.isLive = false;
      this.isEmail = false;
      this.isRegister = false;
      this.isIntegral = false;
    },
    toLive(value) {
      let params = this.$route.query;
      let date = Date.now();
      const maxIndex = this.agendaData.findIndex((item) => new Date(item.date.replace(/-/g, "/")).getTime() > date);

      const index = this.agendaData.findIndex((sub) => sub.date === value.date);
      const obj = { event: "trk", ec: "agenda", ea: "liveentrance", el: index !== -1 ? "day" + (index + 1) : "koltour", };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      if (!this.islogin) {
        this.isRegister = true;
        return false;
      }
      if (ApiToken.flag) {
        if (index == -1) {
          // 逛展直播的时间
          if (date <= new Date("2026-10-12 10:00:00".replace(/-/g, "/")).getTime()) {
            this.liveText = "施耐德电气2026年工博会线上直播<br />将在10月12日上午开启<br />敬请期待！";
            this.isLive = true;
            return false;
          }
        }
        if (index < maxIndex || maxIndex === -1) {
          this.$router.push({
            name: "Live",
            query: {
              track: params.track ? params.track : "",
              utm_source: params.utm_source ? params.utm_source : "",
              utm_medium: params.utm_medium ? params.utm_medium : "",
              utm_campaign: params.utm_campaign ? params.utm_campaign : "",
              utm_content: params.utm_content ? params.utm_content : "",
              se_sr: params.se_sr ? params.se_sr : "",
              se_md: params.se_md ? params.se_md : "",
              se_ct: params.se_ct ? params.se_ct : "",
              livetype: index !== -1 ? index + 1 : 4,
            },
          });
        } else {
          // if (index !== 0) {
          //   this.liveText = "直播未开启，敬请期待!";
          // } else {
          if (index == 0) {
            this.liveText = "施耐德电气2026年工博会线上直播<br />将在10月12日上午开启<br />敬请期待！";
          } else if (index == 1) {
            this.liveText = "施耐德电气2026年工博会线上直播<br />将在10月13日上午开启<br />敬请期待！";
          } else if (index == 2) {
            this.liveText = "施耐德电气2026年工博会线上直播<br />将在10月14日上午开启<br />敬请期待！";
          } else if (index == 3) {
            this.liveText = "施耐德电气2026年工博会线上直播<br />将在10月15日上午开启<br />敬请期待！";
          } else {
            this.liveText = "直播未开启，敬请期待!";
          }
          // }
          this.isLive = true;
        }
      } else {
        this.$router.push({
          name: "Live",
          query: {
            track: params.track ? params.track : "",
            utm_source: params.utm_source ? params.utm_source : "",
            utm_medium: params.utm_medium ? params.utm_medium : "",
            utm_campaign: params.utm_campaign ? params.utm_campaign : "",
            utm_content: params.utm_content ? params.utm_content : "",
            se_sr: params.se_sr ? params.se_sr : "",
            se_md: params.se_md ? params.se_md : "",
            se_ct: params.se_ct ? params.se_ct : "",
            livetype: index !== -1 ? index + 1 : 4,
          },
        });
      }
    },
    handleYDL(index) {
      let params = this.$route.query;
      this.$router.push({
        name: "CloudGuide",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
          tab: index,
        },
      });
    },
    getValidVideoIndex(targetIndex) {
      // 从目标索引开始，向前查找有效的视频项
      for (let i = targetIndex; i >= 0; i--) {
        if (this.agendaData[i] &&
          this.agendaData[i].liveInfo &&
          this.agendaData[i].liveInfo.name &&
          this.agendaData[i].liveInfo.name !== "false" &&
          this.agendaData[i].liveInfo.name.trim() !== '') {
          return i;
        }
      }
      // 如果前面没有找到，从后面找
      for (let i = targetIndex + 1; i < this.agendaData.length; i++) {
        if (this.agendaData[i] &&
          this.agendaData[i].liveInfo &&
          this.agendaData[i].liveInfo.name &&
          this.agendaData[i].liveInfo.name !== "false" &&
          this.agendaData[i].liveInfo.name.trim() !== '') {
          return i;
        }
      }
      return -1;
    },
    getCurrentVideoData() {
      // 获取当前应该显示的视频数据
      // 始终显示 currentVideoIndex 对应的视频内容
      if (this.agendaData[this.currentVideoIndex] &&
        this.agendaData[this.currentVideoIndex].liveInfo &&
        this.agendaData[this.currentVideoIndex].liveInfo.name &&
        this.agendaData[this.currentVideoIndex].liveInfo.name !== "false" &&
        this.agendaData[this.currentVideoIndex].liveInfo.name.trim() !== '') {
        return this.agendaData[this.currentVideoIndex];
      }
      return null;
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    islogin() {
      return this.$store.state.islogin;
    },
    mode() {
      return this.$route.query.mode;
    },
    agendaReverse() {
      let arr = JSON.parse(JSON.stringify(this.agendaData));
      // 过滤掉 liveInfo.name 为 "false" 或空的项
      arr = arr.filter(item => item.liveInfo && item.liveInfo.name && item.liveInfo.name !== "false" && item.liveInfo.name.trim() !== '');

      let obj = {};
      if (!this.kolTrue) {
        // 找到当前视频索引对应的项在过滤后数组中的位置
        const currentVideoItem = this.agendaData[this.currentVideoIndex];
        if (currentVideoItem && currentVideoItem.liveInfo && currentVideoItem.liveInfo.name && currentVideoItem.liveInfo.name !== "false" && currentVideoItem.liveInfo.name.trim() !== '') {
          const currentIndexInFiltered = arr.findIndex(item => item.date === currentVideoItem.date);
          if (currentIndexInFiltered !== -1) {
            obj = arr[currentIndexInFiltered];
            arr.splice(currentIndexInFiltered, 1);
            arr.unshift(obj);
          }
        }
        const i = arr.findIndex((item) => item.liveInfo.name === "工博会 Day1");
        if (i !== -1) {
          arr.splice(i + 1, 0, {
            date: "kol",
            liveInfo: {
              name: "云探工博会",
            },
          });
        }
      } else {
        obj = {
          date: "kol",
          liveInfo: {
            name: "云探工博会",
          },
        };
        arr.unshift(obj);
      }
      return arr;
    },
  },
  watch: {
    scroll(val) {
      var scrollHeight = document.documentElement.scrollHeight;
      var clientHeight = document.documentElement.clientHeight;

      // 获取各个模块元素，如果不存在则跳过
      const id1Element = document.querySelector("#id1");
      const id2Element = document.querySelector("#id2");
      const id3Element = document.querySelector("#id3");
      const id4Element = document.querySelector("#id4");
      const id7Element = document.querySelector("#id7");

      // 由于id1和id2被注释掉了，直接跳到id3
      if (id1Element && id1Element.offsetTop - 80 < val && val <= id2Element.offsetTop - 80) {
        this.$store.commit("activeIndex", 1);
      } else
        if (id2Element && id2Element.offsetTop - 80 < val && val <= id3Element.offsetTop - 80) {
          this.$store.commit("activeIndex", 2);
        } else if (id3Element && id3Element.offsetTop - 80 < val && val <= id4Element.offsetTop - 80) {
          this.$store.commit("activeIndex", 3);
        } else if (id4Element && id4Element.offsetTop - 80 < val && val <= id7Element.offsetTop - 80) {
          this.$store.commit("activeIndex", 4);
          if (scrollHeight - 60 <= val + clientHeight) {
            // 当滚动到页面最底部时，确保最后一个模块高亮
            this.$store.commit("activeIndex", 7);
            // console.log('滚动到页面底部，设置activeIndex: 7')
          }
        } else if (id7Element && id7Element.offsetTop - 80 < val && val < scrollHeight - clientHeight - 80) {
          this.$store.commit("activeIndex", 7);
        } else {
          this.$store.commit("activeIndex", 0);
        }
    },
    mode() {
      if (this.mode) {
        let top = document.querySelector("#" + this.mode).offsetTop;
        document.body.scrollTop = document.documentElement.scrollTop = top - 50;
      }
    },
  },
  beforeDestroy() {
    // 要进行函数卸载
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>